import * as React from "react";

const SvgEmojiUnFlags = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m23.046 19.844-1.415 1.414L16.373 16l-4-4-4.961-4.961-2-2-2.22-2.22 1.414-1.414L7.202 4h7.21l.4 2h5.6v10h-1.21zM5.412 7.867V21h2v-7h4.133l-2-2H7.412V9.867zm7.967 7.967.033.166h.133zM18.412 14h-1.21l-8-8h3.56l.4 2h5.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEmojiUnFlags;
